// extracted by mini-css-extract-plugin
export default {"devider":"EditNotificationSensorNumber_devider__9FjbZ"};